import { render, staticRenderFns } from "./DetailBoxBike.vue?vue&type=template&id=55d88013&scoped=true&"
import script from "./DetailBoxBike.vue?vue&type=script&lang=js&"
export * from "./DetailBoxBike.vue?vue&type=script&lang=js&"
import style0 from "./DetailBoxBike.vue?vue&type=style&index=0&id=55d88013&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d88013",
  null
  
)

export default component.exports